import React from "react";
import { getTrans } from "../../common";
import config from "../../common/config";
import { TransContext } from "../../Context";
import { Consume } from "../../Context/Consumer";

function Maintainance(props) {
  let { TransData } = props;
  const transData = TransData.data;

  return (
    <>
      <div>
        <div className="si-main__container--fluid si-mainMenu__wrap si-bg--black05">
          <div className="si-main__container" />
        </div>
        <div className="si-main__container--fluid">
          <div className="si-main__container">
            <div className="si-um__wrap">
              <div className="si-um__box">
                <div className="si-um__title">
                  <span>
                    {getTrans(transData, "break_in_play", "Break in Play")}
                  </span>
                </div>
                <div className="si-um__para">
                  <p>
                    {getTrans(
                      transData,
                      "maintainence_para_info_one",
                      "We apologize for the inconvenience as the site undergoes maintainence."
                    )}
                  </p>
                  {/* <p>
                    {getTrans(
                      transData,
                      "maintainence_para_info_two",
                      "Don't worry, the stoppage won't be long!"
                    )}
                  </p> */}
                </div>
                <div className="si-um__thumb">
                  <img
                    src={`${config.IMG_BASE}under-maintenance.png`}
                    alt={getTrans(transData, "break_in_play", "Break in Play")}
                    title={getTrans(
                      transData,
                      "break_in_play",
                      "Break in Play"
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Consume(Maintainance, [TransContext]);
